module.exports = __webpack_public_path__ + "img/00029.ef98e754.webp";